// extracted by mini-css-extract-plugin
export var actions = "MigrateToIOMLicenceModal-module--actions--30310";
export var body = "MigrateToIOMLicenceModal-module--body--8704f";
export var flexEnd = "MigrateToIOMLicenceModal-module--flexEnd--4b13f";
export var flexFill = "MigrateToIOMLicenceModal-module--flexFill--d0ddd";
export var infoText = "MigrateToIOMLicenceModal-module--infoText--22d43";
export var label = "MigrateToIOMLicenceModal-module--label--143e4";
export var modal = "MigrateToIOMLicenceModal-module--modal--4d9f2";
export var modalContent = "MigrateToIOMLicenceModal-module--modalContent--2caf7";
export var scrollArea = "MigrateToIOMLicenceModal-module--scrollArea--8659a";
export var submitButton = "MigrateToIOMLicenceModal-module--submitButton--3620e";
export var viewport = "MigrateToIOMLicenceModal-module--viewport--77334";